/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListOrganizationRemoteSessionClientMcpServersSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type ListOrganizationRemoteSessionClientMcpServersRequest = {
  /**
   * The remote_session_client id.
   */
  clientId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type ListOrganizationRemoteSessionClientMcpServersSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const ListOrganizationRemoteSessionClientMcpServersSecurity$outboundSchema:
  z.ZodMiniType<
    ListOrganizationRemoteSessionClientMcpServersSecurity$Outbound,
    ListOrganizationRemoteSessionClientMcpServersSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function listOrganizationRemoteSessionClientMcpServersSecurityToJSON(
  listOrganizationRemoteSessionClientMcpServersSecurity:
    ListOrganizationRemoteSessionClientMcpServersSecurity,
): string {
  return JSON.stringify(
    ListOrganizationRemoteSessionClientMcpServersSecurity$outboundSchema.parse(
      listOrganizationRemoteSessionClientMcpServersSecurity,
    ),
  );
}

/** @internal */
export type ListOrganizationRemoteSessionClientMcpServersRequest$Outbound = {
  client_id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
};

/** @internal */
export const ListOrganizationRemoteSessionClientMcpServersRequest$outboundSchema:
  z.ZodMiniType<
    ListOrganizationRemoteSessionClientMcpServersRequest$Outbound,
    ListOrganizationRemoteSessionClientMcpServersRequest
  > = z.pipe(
    z.object({
      clientId: z.string(),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        clientId: "client_id",
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
      });
    }),
  );

export function listOrganizationRemoteSessionClientMcpServersRequestToJSON(
  listOrganizationRemoteSessionClientMcpServersRequest:
    ListOrganizationRemoteSessionClientMcpServersRequest,
): string {
  return JSON.stringify(
    ListOrganizationRemoteSessionClientMcpServersRequest$outboundSchema.parse(
      listOrganizationRemoteSessionClientMcpServersRequest,
    ),
  );
}
